import { PageShell } from "../components/PageShell";
import { GeneralLogsWidget } from "../components/GeneralLogsWidget";
import { SmtpLogsWidget } from "../components/SmtpLogsWidget";

export const LogsPage = () => {
  return (
    <PageShell
      pageTitle="System Logs"
      subtitle="SMTP delivery logs and general system activity monitoring"
      breadcrumbs={[
        { label: "Home", href: "/" },
        { label: "Service System", href: "/" },
        { label: "Logs" }
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <GeneralLogsWidget />
        <SmtpLogsWidget />
      </div>
    </PageShell>
  );
};
